import * as Models from "./";

export interface IUserModel {
  userId: string;
  displayName: string;
  username: string;
  emailAddress: string;
  suspendWorkIssueNotification: boolean;
  ignoreRecheck: boolean;
  authorityId: string;
  comment: string;
  isApproved: boolean;
  isLocked: boolean;
  isBrokerAgent: boolean;
  windowsUsername: string;
  agentCode: string;
  solicitorNumbers: Array<string>;
  rhodeIslandAuthorization: number;
  partner: Models.PartnerModel.PartnerModel;
  roles: Array<Models.RoleModel.IRoleModel>;
  groups: Array<Models.GroupModel.GroupModel>;
}

export class UserModel implements IUserModel {
  userId: string;
  displayName: string;
  username: string;
  emailAddress: string;
  suspendWorkIssueNotification = false;
  ignoreRecheck = false;
  authorityId: string;
  comment: string;
  isApproved: boolean;
  isLocked: boolean;
  isBrokerAgent: boolean;
  windowsUsername: string;
  agentCode: string;
  solicitorNumbers: Array<string>;
  rhodeIslandAuthorization: number;
  partner: Models.PartnerModel.PartnerModel;
  roles: Array<Models.RoleModel.IRoleModel> = new Array<Models.RoleModel.IRoleModel>();
  groups: Array<Models.GroupModel.GroupModel> = new Array<Models.GroupModel.GroupModel>();
}
